
export const regionMapping = {
  'gardameer': {
    country: 'Italië',
    region: 'Gardameer'
  },
  'garda': {
    country: 'Italië', 
    region: 'Gardameer'
  },
  'lake garda': {
    country: 'Italië',
    region: 'Gardameer'
  },
  'lago di garda': {
    country: 'Italië',
    region: 'Gardameer'
  },
  'costa brava': {
    country: 'Spanje',
    region: 'Costa Brava'
  },
  'costa del sol': {
    country: 'Spanje', 
    region: 'Costa del Sol'
  },
  'algarve': {
    country: 'Portugal',
    region: 'Algarve'
  },
  'toscane': {
    country: 'Italië',
    region: 'Toscane'
  },
  'tuscany': {
    country: 'Italië',
    region: 'Toscane'
  },
  'bretagne': {
    country: 'Frankrijk',
    region: 'Bretagne'
  },
  'brittany': {
    country: 'Frankrijk', 
    region: 'Bretagne'
  },
  'provence': {
    country: 'Frankrijk',
    region: 'Provence'
  },
  'côte d\'azur': {
    country: 'Frankrijk',
    region: 'Côte d\'Azur'
  },
  'french riviera': {
    country: 'Frankrijk',
    region: 'Côte d\'Azur'
  }
};
